
import React from "react"
import { Box, Heading, AspectRatioBox } from "@chakra-ui/core"
import { scaleLinear, scaleTime } from "d3-scale"
import { line } from "d3-shape"
import dayjs from "dayjs"

import LineChart from "../LineChart"

const scales = {
  "3000": { max: 3000, ticks: [0, 1000, 2000, 3000] },
  "4000": { max: 4000, ticks: [0, 2000, 4000] },
  "5000": { max: 6000, ticks: [0, 2000, 4000, 6000] },
  "6000": { max: 6000, ticks: [0, 2000, 4000, 6000] },
  "7000": { max: 9000, ticks: [0, 3000, 6000, 9000] },
  "8000": { max: 9000, ticks: [0, 3000, 6000, 9000] },
  "9000": { max: 9000, ticks: [0, 3000, 6000, 9000] },
  "10000": { max: 10000, ticks: [0, 5000, 10000] },
  "20000": { max: 20000, ticks: [0, 10000, 20000] },
}

const Canton = ({ canton, metaData }) => {

  const max = Math.ceil(metaData.max / 1000) * 1000

  const scaleMetaData = max > 10000 ? scales[20000] : scales[max]

  const x = scaleTime()
    .domain([ dayjs("2020-02-25"), dayjs()])
    .range([8, 104])

  const y = scaleLinear()
    .domain([0, scaleMetaData.max])
    .range([114, 36])

  const lineGenerator = line()
    .x(d => x(new Date(d.date)))
    .y(d => y(d.ncumul_conf))
    .defined(d => d.ncumul_conf !== "MISSING")
  
  const lineGenerator2 = line()
    .x(d => x(new Date(d.date)))
    .y(d => y(d.ncumul_conf))

  const confirmedCases2 = canton.data2
  const confirmedCases = canton.data

  return (
    <AspectRatioBox ratio={1} borderBottom="0.25rem solid" borderColor="gray.300">
      <Box bg="gray.50">
        <Box
          position="absolute"
          fontSize="0.875rem"
          fontWeight={500}
          lineHeight="calc(1em + 0.25rem)"
          color="gray.700"
        >
          <Heading
            as="h3"
            fontSize={["1rem", null, "1.5rem", "0.875rem"]}
            lineHeight={["1.5rem", null, "2rem", "1.25rem"]}
            fontWeight={700}
            letterSpacing="-0.01625em"
            display="inline-block"
            px={["0.5rem", null, "0.75rem", "0.25rem"]}
            py={["0.5rem", null, "0.75rem", "0.25rem"]}
          >
            {canton.name}
          </Heading>
        </Box>

        <LineChart
          lineGenerator={lineGenerator}
          lineGenerator2={lineGenerator2}
          confirmedCases={confirmedCases}
          confirmedCases2={confirmedCases2}
          scaleMetaData={scaleMetaData}
          x={x}
          y={y}
        />

      </Box>
    </AspectRatioBox>
  )
}

export default Canton
